import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

type EmptyWorkspaceProps = {
  title?: IntlKey;
  details?: IntlKey;
};

export const EmptyWorkspace: FC<EmptyWorkspaceProps> = ({
  title = 'emptyWorkspace.title',
  details = 'emptyWorkspace.details',
}) => {
  const { formatMessage } = useIntl();
  return (
    <div className="text-center w-50 m-auto pt-5">
      <i className="icon icon-md form-loading-error-indicator-alert-icon">info_outline</i>
      <h3>{formatMessage({ id: title })}</h3>
      <div>{formatMessage({ id: details })}</div>
    </div>
  );
};
